import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { FilterAlt } from "@mui/icons-material";
import { ButtonGroup } from "@mui/material";
import React, { useEffect } from "react";
import { BoxFlex } from "../../atoms/boxSpaceBtw";
import DropDownFilter from "../../atoms/drop-down-filter";
import { SearchFields } from "../../atoms/my-calender";
import LabeledComponent from "../../molecules/nav-bars/expert-cards-page/labeledComponent";
import { groupedByProject } from "../../molecules/nav-bars/my-calender-page/helper";
import MyCalendarBoxes from "../../organisms/my-calendar-boxes";
import { useMyCalenderContext } from "../../pages/my-calendar/context";
import { LocalDayjs } from "../../utils/timezoneService";
import FilterPopup from "./filters";
import { ArrangeOptions, formatDate, getTotalCalls, isEmpty } from "./helper";
import { textStyle } from "./style";
import ZoomSlots from "./zoomSlots";

export default function MyCalenderWithFilters() {
  const {
    showFilters,
    openFilters,
    closeFilters,
    date,
    setDate,
    CallsDetails,
    isMobile,
    groupData,
    filters,
    setFilters,
  } = useMyCalenderContext();
  const [initialClose, setInitialClose] = React.useState(false);
  React.useEffect(() => {
    if (isMobile && showFilters && !initialClose) {
      closeFilters();
      setInitialClose(true);
    }
  }, [isMobile, showFilters, closeFilters, initialClose]);
  const isCurrentDate = date?.isSame(LocalDayjs(new Date()), "date");

  const call_days = Object.keys(CallsDetails || []);

  return (
    <BoxFlex sx={{ alignItems: "stretch", gap: "1rem" }}>
      {showFilters && (
        <FilterPopup
          closeFilters={closeFilters}
          filters={filters}
          setFilters={setFilters}
          date={date}
          setDate={setDate}
        />
      )}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          px: "1rem",
          pt: "1rem",
          pb: filters.sidebarFilters.zoom_slot ? "0" : "1rem",
          borderRadius: "5px",
          marginBottom: filters.sidebarFilters.zoom_slot ? "0rem" : "2rem",
          width: "100%",
        }}
      >
        {/* Filters ------------------------------------------------ */}

        <BoxFlex
          sx={{
            flexDirection: isMobile ? "column" : "row",
            mb: "1rem",
            width: "100%",
            overflowX: "hidden",
            justifyContent: isMobile ? "space-between" : "space-evenly",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: isMobile ? "space-evenly" : "center",
                alignItems: "center",
              }}
            >
              <SearchFields />
              {!showFilters && (
                <IconButton onClick={openFilters}>
                  <FilterAlt />
                </IconButton>
              )}
            </Box>
            {filters.arrange_tag === "Day" ? (
              <LabeledComponent
                label=""
                component={
                  <DropDownFilter
                    link={null}
                    filterValue={filters.tab}
                    setFilterPayload={(type: string) =>
                      type && setFilters((prev) => ({ ...prev, tab: type }))
                    }
                    dropDownItems={groupedByProject}
                  />
                }
              />
            ) : (
              <Box sx={{ padding: "1.15rem" }}></Box>
            )}
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: isMobile ? "column" : "row" }}
            alignItems={"center"}
            gap={"1rem"}
            mr={"1rem"}
          >
            {!filters.sidebarFilters.zoom_slot && (
              <BoxFlex
                sx={{
                  gap: "1rem",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <ButtonGroup>
                  {ArrangeOptions.map((option) => (
                    <Button
                      variant="outlined"
                      sx={
                        option.value === filters.arrange_tag
                          ? {
                              backgroundColor: "#ec932490 !important",
                              border:
                                "1px solid rgba(236, 147, 36, 0.5) !important",
                              color: "white",
                            }
                          : {}
                      }
                      key={option.value}
                      onClick={() => {
                        setFilters((prev) => ({
                          ...prev,
                          arrange_tag: option.value as "Week" | "Month" | "Day",
                        }));
                      }}
                    >
                      {option.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </BoxFlex>
            )}
            <Stack direction={"column"} alignItems={"center"}>
              {!filters.sidebarFilters.zoom_slot && (
                <Stack direction={"row"} alignItems={"center"}>
                  <IconButton
                    onClick={() =>
                      setDate(
                        date
                          ? date.subtract(
                              1,
                              filters.arrange_tag.toLocaleLowerCase() as any,
                            )
                          : date,
                      )
                    }
                    disableRipple
                  >
                    <ChevronLeft />
                  </IconButton>
                  <Button
                    variant={"outlined"}
                    onClick={() => setDate(LocalDayjs(new Date()))}
                    sx={
                      isCurrentDate
                        ? {
                            backgroundColor: "#ec932490 !important",
                            border:
                              "1px solid rgba(236, 147, 36, 0.5) !important",
                            color: "white",
                          }
                        : {}
                    }
                  >
                    <p style={{ fontSize: "10px" }}>
                      {filters.arrange_tag === "Day"
                        ? "Today"
                        : filters.arrange_tag === "Week"
                        ? "This Week"
                        : "This Month"}
                    </p>
                  </Button>
                  <IconButton
                    onClick={() =>
                      setDate(
                        date
                          ? date.add(
                              1,
                              filters.arrange_tag.toLocaleLowerCase() as any,
                            )
                          : date,
                      )
                    }
                    disableRipple
                  >
                    <ChevronRightIcon />
                  </IconButton>
                </Stack>
              )}
              <p
                style={{
                  ...textStyle,
                  whiteSpace: "nowrap",
                  marginLeft: filters.sidebarFilters.zoom_slot ? "15px" : "0",
                }}
              >
                {date && formatDate(filters.arrange_tag, date, call_days)}
              </p>
            </Stack>

            {!filters.sidebarFilters.zoom_slot && (
              <p
                style={{
                  ...textStyle,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                Total Calls: {CallsDetails ? getTotalCalls(CallsDetails) : 0}
              </p>
            )}
          </Box>
        </BoxFlex>

        {/* -------------------------------------------------------- */}
        {filters.sidebarFilters.zoom_slot ? (
          <ZoomSlots />
        ) : (
          <>
            {CallsDetails && !isEmpty(CallsDetails) ? (
              <MyCalendarBoxes
                arrangeBy={filters.arrange_tag}
                CallsDetails={CallsDetails}
                groupData={groupData}
                isGroupedByAm={filters.tab === "groupedbyAM"}
              />
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "16px",
                  color: "#252B3B",
                }}
              >
                There is no data to display for the given {filters.arrange_tag}.
              </Typography>
            )}
          </>
        )}
      </Box>
    </BoxFlex>
  );
}
